import React, { useEffect, useState } from "react";
import { DataEntryField } from "./DataEntryField";
import { TimeControl, TimeFieldChangeResult } from "../controls/TimeControl";
import { Time } from "../../pace-fns/pace-fns";

type Props = {
  time: Time;
  onChange(isValid: boolean, time?: Time): void;
  selectField: () => void;
  isCalculable: boolean;
};


export const TimeEntryField = ({
  time,
  selectField,
  isCalculable,
  onChange
}: Props) => {
  const [timeState, setTimeState] = useState(time);
  const onTimeChange = (changeResult: TimeFieldChangeResult) => {
    changeResult.valid
      ? onChange(changeResult.valid, changeResult.data.value)
      : onChange(false);
  };

  useEffect(() => {
    setTimeState(time);
  }, [time]);

  const TimeEntryField = (
    <TimeControl onTimeChange={onTimeChange} time={timeState}></TimeControl>
  );

  return (
    <DataEntryField
      fields={[TimeEntryField]}
      isCalculable={isCalculable}
      onSelect={selectField}
    ></DataEntryField>
  );
};
